var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-input',_vm._g(_vm._b({attrs:{"validation":_vm.validation},on:{"input":function($event){_vm.localText = $event}}},'the-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }